/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiOrderSnapshot } from '@Model';
import type { HttpActions, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of OrderSnapshotsController.
 */
export class OrderSnapshotsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /orders/snapshots/{orderSnapshotId}
     */
    public get(orderSnapshotId: string): Promise<Result<ApiOrderSnapshot>> {
        return this.http.get<Result<ApiOrderSnapshot>>(`/orders/snapshots/${orderSnapshotId}`);
    }
}
